import { Stack } from '@zet/design-system'
import { Control, Controller, FieldValues } from 'react-hook-form'

import { IOcField, IOcFieldError } from '../../utils/types'
import FormComponent from './FormComponent'
import useRules from './useRules'

interface Props {
  control: Control<FieldValues, any>
  ocFieldError?: IOcFieldError
  ocField: IOcField
}

const FormController: React.FC<Props> = (props) => {
  const { control, ocFieldError, ocField } = props

  const { isHide } = useRules({
    control,
    rules: ocField?.rules?.[0]?.rules,
  })

  if (isHide) {
    return null
  }

  return (
    <Controller
      control={control}
      name={String(ocField?.code ?? '')}
      render={(formControllerRenderProps) => {
        return (
          <Stack className="my-2">
            <FormComponent
              formControllerRenderProps={formControllerRenderProps}
              formValidationError={formControllerRenderProps.fieldState.error}
              ocFieldError={ocFieldError}
              ocField={ocField}
            />
          </Stack>
        )
      }}
    />
  )
}

export default FormController
